import { Control, FieldArrayPath } from 'react-hook-form';
import { FormNInputGroups } from './form-n-input-groups';

export function FormNInputs<FormType>({
    name,
    propertyName,
    label,
    control,
    buttonSize,
}: {
    name: FieldArrayPath<FormType>;
    propertyName: string;
    label: string;
    buttonSize?: 'sm' | 'md' | 'lg' | 'xl';
    control: Control<FormType>;
}) {
    return (
        <FormNInputGroups
            groupName={name}
            groupLabel={label}
            buttonSize={buttonSize}
            properties={[
                {
                    propertyName,
                    propertyLabel: label,
                },
            ]}
            control={control}
        />
    );
}
